import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.6316 7.88V6.21053L18.8421 2v3.15789H22l-4.2105 4.21053H16.12l-3.9021 3.90208c-.2053.2053-.4747.3084-.7442.3084-.2695 0-.539-.1031-.7442-.3084-.4116-.4116-.4116-1.0768 0-1.4884L14.6316 7.88z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5337 10.1126l-.0769.0779c.2464.7348.3853 1.519.3853 2.3358 0 4.0621-3.3063 7.3684-7.3684 7.3684-4.06212 0-7.36844-3.3063-7.36844-7.3684 0-4.06209 3.30632-7.36841 7.36844-7.36841.8168 0 1.6.13895 2.3358.38527l.0779-.07684 1.541-1.54106c-1.2052-.55473-2.541-.87263-3.9547-.87263C6.24105 3.05263 2 7.29368 2 12.5263 2 17.7589 6.24105 22 11.4737 22c5.2326 0 9.4737-4.2411 9.4737-9.4737 0-1.4137-.3179-2.74946-.8727-3.95472l-1.541 1.54102z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4737 9.36842c.0323 0 .0633.00443.0941.00883.0233.00333.0465.00665.0701.00801l1.7495-1.74947c-.5937-.23368-1.2358-.37263-1.9137-.37263-2.90738 0-5.26317 2.35579-5.26317 5.26314 0 2.9074 2.35579 5.2632 5.26317 5.2632 2.9074 0 5.2631-2.3558 5.2631-5.2632 0-.6779-.1389-1.32-.3726-1.9137l-1.7495 1.7495c.0014.0236.0047.0468.0081.0701.0043.0308.0088.0618.0088.0941 0 1.7411-1.4169 3.1579-3.1579 3.1579-1.74107 0-3.15791-1.4168-3.15791-3.1579 0-1.741 1.41684-3.15788 3.15791-3.15788z",
    fill: "currentColor"
  }));
});